export default "__VITE_ASSET__BPVyz7Uv__"